import React from 'react';
import CIcon from '@coreui/icons-react';
import swal from 'sweetalert';
import { clear, getObjectData } from './services/Storage';
import {
   cilCalendar,
   cilCog,
   cilDescription,
   cilPlus,
   cilSpeedometer,
   cilTruck,
   cilArrowThickFromRight,
   cilUser,
   cilGroup,
} from '@coreui/icons';
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react';

const CustomNavItem = ({ name, to, icon }) => (
   <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
   >
      <CNavItem name={name} icon={icon} />
   </a>
);

const logoutAlert = (e) => {
   e.preventDefault();
   try {
      swal({
         icon: 'warning',
         title: 'Are you sure?',
         text: 'Log Out from this session',
         type: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#DD6B55',
         confirmButtonText: 'LogOut',
         cancelButtonText: 'Cancel',
         buttons: true,
      }).then(async (value) => {
         if (value) {
            logoutUser();
         } else return;
      });
   } catch (error) {
      toast.error('Some Error Occured!');
   }
};

const logoutUser = async (e) => {
   await clear();
   window.location = '/login';
};
// Station Admin SideBar Navigation:
const _adminNav = [
   {
      component: CNavItem,
      name: 'Dashboard',
      to: '/dashboard',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
   },
   {
      component: CNavItem,
      name: 'Schedule',
      to: '/schedule',
      icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
   },
   {
      component: CNavItem,
      name: 'Service Request',
      to: '/addleads',
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
   },
   // {
   //    component: CNavItem,
   //    name: 'Manage Services',
   //    to: '/services-list',
   //    icon: <CIcon icon={cilPlus} customClassName="nav-icon" />,
   // },
   {
      component: CNavItem,
      name: 'Payment',
      to: '/schedule-list',
      icon: <CIcon icon={cilCog} customClassName="nav-icon" />,
   },
   // {
   //    component: CNavItem,
   //    name: 'Manage Services',
   //    to: '/services-add',
   //    icon: <CIcon icon={cilPlus} customClassName="nav-icon" />,
   // },
   

   
   
];

// super Admin SideBar Navigation:
const _nav = [
   {
      component: CNavItem,
      name: 'Dashboard',
      to: '/dashboard',
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
      badge: {
         color: 'info',
         text: 'NEW',
      },
   },
   {
      component: CNavTitle,
      name: 'Pages',
   },
   {
      component: CNavItem,
      name: 'Write Blog',
      to: 'https://cms.inspectthiscar.com/admin/auth/login',
      target: '_blank',
      icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
   },
   // {
   //    component: CNavItem,
   //    name: 'Add Station',
   //    to: '/station-add',
   //    icon: <CIcon icon={cilPlus} customClassName="nav-icon" />,
   // },

   {
      component: CNavItem,
      name: 'Stations',
      to: '/stations',
      icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
   },
   {
      component: CNavItem,
      name: 'Services',
      to: '/add-services',
      icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
   },
   // {
   //    component: CNavItem,
   //    name: 'Schedule List',
   //    to: '/schedule-list',
   //    icon: <CIcon icon={cilCog} customClassName="nav-icon" />,
   // },
   // {
   //    component: CNavItem,
   //    name: 'Appointment Schedule',
   //    to: '/schedule',
   //    icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
   // },

   {
      component: CNavTitle,
      name: 'Authentication',
   },

   {
      component: CNavItem,
      name: 'Profile',
      to: '/',
      icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
   },

   {
      component: CNavItem,
      onClick: logoutAlert,
      name: 'Logout',
      to: '#',
      icon: <CIcon icon={cilArrowThickFromRight} customClassName="nav-icon" />,
   },
   // {
   //   component: CNavItem,
   //   name: 'Settings',
   //   to: '/settings',
   //   icon: <CIcon icon={cilCog} customClassName="nav-icon" />,
   // },
];

export { _nav, _adminNav };
